import axios from 'axios'
import * as moment from 'moment' // TODO: put in global
import dragVerify from 'vue-drag-verify'

import menuStore from '@/stores/menu-store.js'
import toastStore from '@/stores/toast-store.js'
import DeliveryQrModal from '@/vcs/_shared/modals/delivery-qr/cmp.vue'
import EditDeliveryRequestCommentModal from '@/vcs/_shared/modals/edit-delivery-request-comment/cmp.vue'
import CollectPackageScreen from '@/vcs/_shared/modals/collect-package-screen/cmp.vue'
import QrModal from '@/vcs/_shared/modals/QrModal.vue'

export default {
  name: 'DeliveryRequest',
  props: {
    delivery: Object,
    scenarioKey: String,
  },
  data: function () {
    return {
      deliveryRequestWidth: 200,
      blocker: false,
      isSliderVisible: true,
    }
  },
  mounted() {
    this.deliveryRequestWidth = this.$refs.deliveryRequest.offsetWidth - 40
  },
  computed: {
    isDeliverySecenarioByDelivery() {
      return this.delivery.deliveryScenario == 'by_deliverer'
    },
    isDeliverySecenarioByUser() {
      return this.delivery.deliveryScenario == 'by_user'
    },
    reciverData() {
      const {
        reciverEmail,
        reciverName,
        reciverPhone,
        reciverPhonePrefix,
        isForAnonymousUser,
        phone,
        phonePrefix,
      } = this.delivery

      // anonymous return
      if (isForAnonymousUser) {
        return `+${phonePrefix} ${phone}`
      }

      let fullPhoneNumber = null
      if (reciverPhone && reciverPhonePrefix) {
        fullPhoneNumber = `+${reciverPhonePrefix} ${reciverPhone}`
      } else if (reciverPhone && !reciverPhonePrefix) {
        fullPhoneNumber = reciverPhone
      }

      // reciver return
      return [reciverEmail, reciverName, fullPhoneNumber]
        .filter(key => {
          return !!key
        })
        .join('; ')
    },
    skipLocationTrue() {
      return window.localStorage.getItem('skipLocalizationCheck') == 'true'
    },
    skipLocationFalse() {
      return window.localStorage.getItem('skipLocalizationCheck') == 'false'
    },
    hasDeliveryEnded() {
      const statuses = [
        'completed',
        'not_collected',
        'removed_by_support',
        'collected',
        'collection_attempt_dailed',
      ]
      return statuses.includes(this.delivery.status)
    },
  },
  methods: {
    formatedExpirationDay(date) {
      return date ? moment(new Date(date)).format('DD.MM.YYYY') : '-'
    },

    formatedQuarantineDate(date) {
      return date ? moment(new Date(date)).format('DD.MM.YYYY HH:mm') : '-'
    },

    formatedExpirationHours(date) {
      return date ? moment(new Date(date)).format('HH:mm') : ''
    },

    copyKey() {
      const el = document.createElement('textarea')
      this.hasDeliveryEnded
        ? (el.value = `tel: +${this.delivery.phonePrefix} ${this.delivery.phone}, kod: ${this.delivery.collectionKey}`)
        : (el.value = `tel: +${this.delivery.phonePrefix} ${this.delivery.phone}, kod: ${this.delivery.deliveryKey}`)
      document.body.appendChild(el)

      if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        var editable = el.contentEditable
        var readOnly = el.readOnly

        el.contentEditable = true
        el.readOnly = true

        var range = document.createRange()
        range.selectNodeContents(el)

        var selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        el.setSelectionRange(0, 999999)

        el.contentEditable = editable
        el.readOnly = readOnly
      } else {
        el.select()
      }

      document.execCommand('copy')
      document.body.removeChild(el)
      toastStore.commit('success', { message: this.$t('deliveries.copiedToClipboard') })
    },

    collectDeliveryRequest(boxId, cpId) {
      this.blocker = true
      this.isSliderVisible = false
      axios({
        method: 'put',
        url: `delivery_requests/${this.delivery.id}/collect`,
      })
        .then(() => {
          this.isSliderVisible = true
          mainApp.$emit(`updateDeliveryRequests`)
          toastStore.commit('success', { message: this.$t('deliveries.boxOpen') })
          this.triggerCollectPackageScreenModal(boxId, cpId)
        })
        .catch(error => {
          this.isSliderVisible = true
          mainApp.$emit(`updateDeliveryRequests`)

          let errorMessage
          if (error.response.status == 422 && error.response.data.errors.flow == 'dr:16') {
            errorMessage = `${this.$t('messages.quarantineError')} ${this.formatedQuarantineDate(
              error.response.data.quarantineTimeEndsAt,
            )}`
            toastStore.commit('error', { message: errorMessage, persistTime: 6000 })
          } else {
            this.$errorHumanized({ error })
          }
        })
        .finally(() => {
          this.blocker = false
        })
    },

    triggerCollectPackageScreenModal(boxId, cpId) {
      this.$store.commit('modal/open', {
        cmp: CollectPackageScreen,
        animation: 'slide-down-menu',
        callback: this.collectCallback,
        data: {
          boxId: boxId,
          cpId: cpId,
          type: 'delivery',
        },
      })
    },

    // menu and callbacks
    openMenu() {
      const buttons = [
        {
          text: this.$t('menu.editComment'),
          callback: this.editComment,
          color: '#009bde',
        },
        {
          text: this.hasDeliveryEnded
            ? this.$t('menu.displayQrPickupCode')
            : this.$t('menu.displayQrDeliveryCode'),
          callback: this.openDeliveryQrModal,
          color: '#009bde',
        },
      ]

      this.delivery.status == 'brand_new'
        ? buttons.push({
            text: 'Odwołaj rezerwację',
            callback: this.abortDeliveryRequest,
            color: '#e01a66',
          })
        : null
      menuStore.commit('open', buttons)
    },

    openDeliveryQrModal() {
      menuStore.commit('close')
      this.$store.commit('modal/open', {
        cmp: DeliveryQrModal,
        animation: 'slide-down-menu',
        callback: this.collectCallback,
        data: {
          id: this.delivery.id,
          hasDeliveryEnded: this.hasDeliveryEnded,
        },
      })
    },

    collectCallback() {
      mainApp.$emit(`updateDeliveryRequests`)
    },

    abortDeliveryRequest() {
      menuStore.commit('close')
      axios({
        method: 'put',
        url: `delivery_requests/${this.delivery.id}/abort`,
      })
        .then(response => {
          mainApp.$emit(`updateDeliveryRequests`)
          console.log('response abortDeliveryRequest', response)
        })
        .catch(error => {
          console.error('error abortDeliveryRequest', error)
        })
    },

    editComment() {
      menuStore.commit('close')
      this.$store.commit('modal/open', {
        cmp: EditDeliveryRequestCommentModal,
        animation: 'slide-down-menu',
        data: { deliveryRequest: this.delivery },
      })
    },

    checkIfCollectomateHasAuthQr(dr) {
      if (!!dr.collectionPoint.hasAuthorizationQr && this.skipLocationFalse) {
        this.openQrModal(dr)
      } else {
        this.collectDeliveryRequest(dr.boxId, dr.collectionPointId)
      }
    },

    openQrModal(dr) {
      this.$store.commit('modal/open', {
        cmp: QrModal,
        size: 'full',
        callback: qr => {
          this.checkIfDrBelogsToThisCollectomateBeforeCollect({
            qr: qr,
            dr: dr,
            collectFn: this.collectDeliveryRequest,
          })
        },
        animation: 'slide-down-menu',
      })

      this.rerenderSlider()
    },

    checkIfDrBelogsToThisCollectomateBeforeCollect(args) {
      const { qr, dr, collectFn } = args

      axios({
        method: 'post',
        url: `/auth/collection_points/confirm_cp_by_qr`,
        params: {
          authorizationQr: qr,
          collectionPointId: dr.collectionPointId,
        },
      })
        .then(response => {
          console.log('response', response)
          collectFn(dr.boxId, dr.collectionPointId)
        })
        .catch(error => {
          toastStore.commit('error', { message: this.$t('messages.cannotCollect') })
        })
    },

    rerenderSlider() {
      this.isSliderVisible = false
      this.$nextTick(() => {
        this.isSliderVisible = true
      })
    },
  },
  components: {
    dragVerify,
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
